import * as removeNode from 'unist-util-remove';
export var handleKeywordsOfNode = function (tree, node, keywordHandler) {
  if (node.children.length > 0 && node.children[0].type == 'paragraph') {
    var paragraph = node.children[0];
    if (paragraph.children.length > 0 && paragraph.children[0].type == 'text') {
      var textNode = paragraph.children[0];
      var keywords = extractKeywords(textNode.value);
      keywords.forEach(function (k) {
        keywordHandler(k);
      });
      var cleaned = stripTextFromKeywords(textNode.value);
      if (cleaned != '') {
        textNode.value = cleaned;
      } else if (paragraph.children.length > 1) {
        removeNode(tree, textNode);
      } else if (paragraph.children.length == 1 && node.children.length > 1) {
        removeNode(tree, paragraph);
      } else if (paragraph.children.length == 1 && node.children.length == 1) {
        removeNode(tree, node);
      }
    }
  }
};
var KEYWORD_MATCHER = /\{\?(.+)\} ?/;
var extractKeywords = function (text) {
  var match = text.match(KEYWORD_MATCHER);
  if (!match) {
    return [];
  }
  return match[1].split('|');
};
var stripTextFromKeywords = function (text) {
  return text.replace(KEYWORD_MATCHER, '');
};